import { clone } from "../utils";
import * as evaluationFunctions from "./evaluationFunctions";

export function mergeFieldValueAndFieldType(blocValues, blocTypes, blocId, blocType, fieldType) {
    let bloc = blocValues.find((b) => b.mobile_id === blocId);
    let fieldsValue = bloc.field_ids;

    if (fieldType) {
        let blocTypeId = fieldType.block_type_id;
        if (!blocTypeId && fieldType.parent_id) {
            blocTypeId = bloc.type_id;
            let fieldValue = fieldsValue.find((f) => f.type_id === fieldType.parent_id);
            let childrenFieldsValue = fieldValue.value_field_ids;
            return mergeComplexeFieldValueAndFieldType(childrenFieldsValue, blocTypes, fieldType.parent_id, blocTypeId);
        }

        if (!blocType) blocType = blocTypes.find((bt) => bt.id === blocTypeId);
    }

    let fieldTypes = blocType.field_ids;

    let fields = [];
    fieldsValue.forEach((fv) => {
        fieldTypes.forEach((ft) => {
            if (fv.type_id === ft.id) {
                let field = Object.assign(clone(fv), clone(ft));
                fields.push(field);
            }
        });
    });

    return fields;
}

export function mergeComplexeFieldValueAndFieldType(fieldsValue, blocTypes, modelParentId, blocTypeId) {
    let blocType = blocTypes.find((bt) => bt.id === blocTypeId);
    let fieldType = blocType.field_ids.find((f) => f.id === modelParentId);

    let fields = [];
    fieldsValue.forEach((fv) => {
        let id = fv.id;
        let field = Object.assign(fv, fieldType);
        field.master_type_id = fieldType.id;
        field.id = id;
        fields.push(field);
    });

    return fields;
}

export function evaluateDynamicPropertyOfField(fields, model, dynamicPropertyName, defaultValue, stateAccessor) {
    let field;
    let fieldTypeId = model.id;

    if (model.parent_id) {
        fieldTypeId = model.parent_id;
        let fieldMaster = fields.find((f) => f.master_type_id === fieldTypeId);
        field = fieldMaster.field_type_ids.find((f) => f.id === model.id);
    } else {
        field = fields.find((f) => f.type_id === fieldTypeId);
    }

    if (!field)
        return (
            "Impossible de vérifier l'évaluation de la propriété " +
            dynamicPropertyName +
            " sur le champ " +
            fieldTypeId +
            " car il est introuvable"
        );

    if (!field[dynamicPropertyName]) return defaultValue;

    return evaluateDynamicProperty(fields, field, dynamicPropertyName, stateAccessor);
}

export function evaluateDynamicPropertyOfBloc(fields, model, dynamicPropertyName, defaultValue, stateAccessor) {
    if (!model[dynamicPropertyName]) return defaultValue;

    return evaluateDynamicProperty(fields, model, dynamicPropertyName, stateAccessor);
}

export function lafonction(json, fields, stateAccessor, x = undefined) {
    let args1 = json["args1"];
    let args2 = json["args2"];
    let operator = json["operator"];

    // CECI...
    let value1 = getValueFromArgs(args1, fields, stateAccessor, x);

    if (typeof args2 !== "undefined") {
        let value2 = getValueFromArgs(args2, fields, stateAccessor, x);

        switch (operator) {
            case "&&":
                return value1 && value2;
            case "||":
                return value1 || value2;
            case ">":
                return value1 > value2;
            case "<":
                return value1 < value2;
            case "==":
                return value1 == value2;
            case "===":
                return value1 === value2;
            case "!=":
                return value1 != value2;
            case "!==":
                return value1 !== value2;
            case "==>":
                if (typeof value2 === "string") {
                    return value1 ? value2 : "";
                }
                if (typeof value2 === "number") {
                    return value1 ? value2 : 0;
                }
                return value1 ? value2 : undefined;
            case "+":
                return value1 + value2;
            default:
                throw new Error("Unknown operator " + operator);
        }
    }

    return value1;
}

function getValueFromArgs(args, fields, stateAccessor, x = undefined) {
    if (typeof args === "object" && !Array.isArray(args) && args !== null) {
        args = lafonction(args, fields, stateAccessor, x);
    }

    let value = args;
    if (typeof args === "string") {
        let negated = false;
        const trimmed = args.trim();
        if (trimmed.startsWith("!")) {
            negated = true;
            args = trimmed.slice(1);
        } else {
            args = trimmed;
        }
        const extract = extractDoubleBracket(args);
        if (extract) {
            const split = extract.match(/[^.()]+(?:\([^()]*\))?/g);
            if (split[0] === "evaluationFunctions") {
                value = evaluationFunctions;
            } else {
                if (split[0] === "stateAccessor") {
                    value = stateAccessor;
                } else if (split[0] === "x") {
                    if (typeof x === "undefined") {
                        console.error("Le paramètre x de l'expression du find/filter n'est pas défini !");
                        return;
                    }
                    value = x;
                } else {
                    value = fields.find((f) => f.code === split[0]);
                    if (!value) {
                        console.error(`Field not found: ${split[0]}`);
                        return;
                    }
                }

                if (split.length > 1) {
                    value = getRecursiveValueFromObj(value, split.slice(1).join("."), fields, stateAccessor);
                }
            }
        }
        const splitMethod = args.match(/\{\{.*?\}\}\.(\w+\([^)]*\))/);
        if (splitMethod && splitMethod.length > 1) {
            const method = splitMethod[1];
            if (isFunctionCall(method)) {
                const functionName = getFunctionName(method);
                var stringParams = extractParams(method) || [];
                var params = [];
                stringParams.forEach((stringParams) => {
                    var varParamMatch = stringParams.match(/\{\{(.+?)\}\}/);
                    if (varParamMatch) {
                        const varParam = varParamMatch[1].match(/[^.()]+(?:\([^()]*\))?/g);
                        let paramValue;
                        if (varParam[0] === "stateAccessor") {
                            paramValue = stateAccessor;
                        } else if (varParam[0] === "x") {
                            if (typeof x === "undefined") {
                                console.error("Le paramètre x de l'expression du find/filter n'est pas défini !");
                                return;
                            }
                            paramValue = x;
                        } else {
                            let field = fields.find((f) => f.code === varParam[0]);
                            if (!field) {
                                console.error(`Field not found: ${varParam[0]}`);
                                return;
                            }
                            paramValue = field;
                        }

                        if (varParam.length > 1) {
                            paramValue = getRecursiveValueFromObj(
                                paramValue,
                                varParam.slice(1).join("."),
                                fields,
                                stateAccessor
                            );
                        }
                        params.push(paramValue);
                    } else {
                        const parsed =
                            stringParams === "true"
                                ? true
                                : stringParams === "false"
                                  ? false
                                  : stringParams === "undefined"
                                    ? undefined
                                    : !isNaN(stringParams)
                                      ? Number(stringParams)
                                      : stringParams.trim().replace(/^['"]+|['"]+$/g, "");
                        params.push(parsed);
                    }
                });
                switch (functionName) {
                    case "checkProdlotListCorrectlyFilled":
                        value = value.checkProdlotListCorrectlyFilled(...params);
                        break;
                    case "checkFluidTypesOk":
                        value = value.checkFluidTypesOk(...params);
                        break;
                    case "checkFluidQuantitiesOk":
                        value = value.checkFluidQuantitiesOk(...params);
                        break;
                    case "getFluidDetectorMark":
                        value = value.getFluidDetectorMark(...params);
                        break;
                    case "getFluidDetectorModel":
                        value = value.getFluidDetectorModel(...params);
                        break;
                    case "getFluidDetectorId":
                        value = value.getFluidDetectorId(...params);
                        break;
                    case "getFluidDetectorDate":
                        value = value.getFluidDetectorDate(...params);
                        break;
                    case "today":
                        value = value.today();
                        break;
                    case "getStartHourOfIntervention":
                        value = value.getStartHourOfIntervention(...params);
                        break;
                    case "getDefaultContactAttribute":
                        value = value.getDefaultContactAttribute(...params);
                        break;
                    case "getCerfaSubTitle":
                        value = value.getCerfaSubTitle(...params);
                        break;
                    case "substring":
                        value = value.substring(...params);
                        break;
                    default:
                        throw new Error("Unknown method " + functionName);
                }
            }
        }

        const isNumeric = (v) => v !== "" && !isNaN(v);
        if (!args.includes("{{") && !args.includes(".")) {
            value =
                value === "true"
                    ? true
                    : value === "false"
                      ? false
                      : value === "undefined"
                        ? undefined
                        : value === "x"
                          ? x
                          : isNumeric(value)
                            ? Number(value)
                            : value.trim().replace(/^['"]+|['"]+$/g, "");
        }

        if (negated) {
            value = !value;
        }
    }

    return value;
}

function getRecursiveValueFromObj(obj, params, fields, stateAccessor) {
    if (typeof params !== "string") {
        console.error("params must be a string");
        return;
    }

    var split = params.match(/[^.()]+(?:\([^()]*\))?/g);
    if (isFunctionCall(split[0])) {
        const functionName = getFunctionName(split[0]);
        const functionCondition = extractParamsWithoutSpliting(split[0]);
        try {
            const jsonCondition = JSON.parse(functionCondition);
            let result;
            switch (functionName) {
                case "find":
                    result = obj.find((x) => lafonction(jsonCondition, fields, stateAccessor, x));
                    break;
                case "filter":
                    result = obj.filter((x) => lafonction(jsonCondition, fields, stateAccessor, x));
                    break;
                default:
                    throw new Error("Unknown method " + functionName);
            }

            if (result) {
                if (split.length > 1) {
                    return getRecursiveValueFromObj(result, split.slice(1).join("."), fields, stateAccessor);
                }
            }
            return result;
        } catch (e) {
            console.error("Invalid JSON condition:", functionCondition);
            return;
        }
    } else {
        if (typeof obj === "undefined" || obj === null) return;
        var value = obj[split[0]];
        if (split.length > 1) {
            return getRecursiveValueFromObj(value, split.slice(1).join("."), fields, stateAccessor);
        }
    }

    return value;
}

function isFunctionCall(str) {
    return /\w+\s*\(.*\)/.test(str);
}

function getFunctionName(str) {
    const match = str.match(/^([a-zA-Z_$][a-zA-Z0-9_$]*)\s*\(/);
    return match ? match[1] : null;
}

function extractParams(str) {
    const match = str.match(/\((.*?)\)/);
    return match ? match[1].split(",") : null;
}

// Pour l'extractuion des valeurs js
function extractDoubleBracket(str) {
    const start = str.indexOf("{{");
    if (start === -1) return null;

    let depth = 0;

    for (let i = start; i < str.length; i++) {
        if (str[i] === "{" && str[i + 1] === "{") {
            depth++;
            i++;
        } else if (str[i] === "}" && str[i + 1] === "}") {
            depth--;
            i++;
            if (depth === 0) {
                return str.slice(start + 2, i - 1);
            }
        }
    }

    return null;
}

function extractParamsWithoutSpliting(str) {
    const match = str.match(/\((.*?)\)/);
    return match ? match[1] : null;
}

export function evaluateDynamicProperty(fields, fieldOrBloc, dynamicPropertyName, stateAccessor) {
    let stringEvaluation = fieldOrBloc[dynamicPropertyName];
    if (stringEvaluation.includes("return")) {
        let fieldsCodesNeeded = getFromBetween.get(fieldOrBloc[dynamicPropertyName], "{{", "}}");
        let fieldsValuesNeeded = [];
        let fieldMissing = false;
        fieldsCodesNeeded.forEach((fcn) => {
            let field = fields.find((f) => f.code === fcn);

            if (fcn === "evaluationFunctions") fieldsValuesNeeded.push(evaluationFunctions);
            else if (fcn === "stateAccessor") {
                fieldsValuesNeeded.push(stateAccessor);
            } else {
                if (!field) fieldMissing = fcn;

                fieldsValuesNeeded.push(field);
            }
        });

        if (fieldMissing)
            return (
                "Impossible de vérifier l'évaluation de la propriété " +
                dynamicPropertyName +
                " sur le champ ou le bloc " +
                fieldOrBloc.id +
                " car le code [" +
                fieldMissing +
                "] spécifié dans l'évaluation est introuvable"
            );

        let regexCurlyBracketStart = /{{/g;
        let regexCurlyBracketEnd = /}}/g;

        let transformedStringEvaluation = fieldOrBloc[dynamicPropertyName]
            .replace(regexCurlyBracketStart, "")
            .replace(regexCurlyBracketEnd, "");
        //fieldsCodesNeeded => Codes des champs à remplacer
        //transformedStringEvaluation => Evaluation où les doubles accolades ont été remplacées
        let evaluator = new Function(fieldsCodesNeeded, transformedStringEvaluation); // eslint-disable-line
        //Exécute l'évaluation en remplaçant les codes par les valeurs de fieldsValuesNeeded
        try {
            return evaluator(...fieldsValuesNeeded);
        } catch (error) {
            console.error(error);
            return (
                "Impossible de vérifier l'évaluation de la propriété " +
                dynamicPropertyName +
                " sur le champ ou le bloc " +
                fieldOrBloc.id
            );
        }
    } else {
        try {
            let json = JSON.parse(stringEvaluation);
            var result = lafonction(json, fields, stateAccessor);
            return result;
        } catch (e) {
            console.error("Invalid JSON condition:", stringEvaluation);
            return;
        }
    }
}

export function checkDynamicPropertyOfField(fields, model, dynamicPropertyName, defaultValue, stateAccessor) {
    let evaluationResult = evaluateDynamicPropertyOfField(
        fields,
        model,
        dynamicPropertyName,
        defaultValue,
        stateAccessor
    );

    if (typeof evaluationResult !== "boolean" && typeof evaluationResult !== "string")
        return "L'évaluation retournée n'est ni un booléen ni une chaine de caractère. Veuillez vérifier le paramétrage";

    return evaluationResult;
}

var getFromBetween = {
    results: [],
    string: "",
    getFromBetween: function (sub1, sub2) {
        if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
        var SP = this.string.indexOf(sub1) + sub1.length;
        var string1 = this.string.substr(0, SP);
        var string2 = this.string.substr(SP);
        var TP = string1.length + string2.indexOf(sub2);
        return this.string.substring(SP, TP);
    },
    removeFromBetween: function (sub1, sub2) {
        if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
        var removal = sub1 + this.getFromBetween(sub1, sub2) + sub2;
        this.string = this.string.replace(removal, "");
    },
    getAllResults: function (sub1, sub2) {
        // first check to see if we do have both substrings
        if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return;

        // find one result
        var result = this.getFromBetween(sub1, sub2);
        // push it to the results array
        this.results.push(result);
        // remove the most recently found one from the string
        this.removeFromBetween(sub1, sub2);

        // if there's more substrings
        if (this.string.indexOf(sub1) > -1 && this.string.indexOf(sub2) > -1) {
            this.getAllResults(sub1, sub2);
        } else return;
    },
    get: function (string, sub1, sub2) {
        this.results = [];
        this.string = string;
        this.getAllResults(sub1, sub2);
        return this.results;
    },
};

export function getStateAccessor(props) {
    let stateAccessor = {};

    if (!props) {
        console.warn("Attention, l'accessor n'a pu être généré correctement");
        return stateAccessor;
    }

    stateAccessor.loggedEmployee = props.loggedEmployee;
    stateAccessor.fluidBottles = props.fluidBottles;
    stateAccessor.intervention = props.intervention;
    stateAccessor.sppFound = props.sppFound;
    return stateAccessor;
}

/**** exemple avec somme de plusieurs champs
const fake_fields = [
    {
        code: "QUANTITE_PREVI",
        stringEvaluation: "return true;",
        value: 60,
    },
    {
        code: "QUANTITE_REEL",
        stringEvaluation: "return {{QUANTITE_PREVI}}.value === {{QUANTITE_REEL}}.children.map((c) => c.value).reduce((sum, currentValue) => sum + currentValue)",
        value: 6,
        children: [
            {
                code: "QUANTITE_PREVI",
                stringEvaluation: "return true;",
                value: 54,
            },
            {
                code: "QUANTITE_PREVI",
                stringEvaluation: "return true;",
                value: 6,
            }
        ]
    }
]
*/
